import React from 'react';
import { DataTable, SectionHeader, StatusPill } from '../components';

export function ContentPage({ rows }) {
  return (
    <div>
      <SectionHeader
        title="Content"
        subtitle={`${rows.content?.length || 0} pieces`}
      />
      <DataTable
        testid="dash-content-table"
        rows={rows.content}
        emptyText="No content yet."
        columns={[
          { key: 'title', label: 'Title' },
          { key: 'type',  label: 'Type', nowrap: true,
            render: r => <span style={{
              padding: '2px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600,
              background: 'rgba(15,15,30,0.05)', color: 'var(--dash-text-muted)',
              textTransform: 'capitalize',
            }}>{r.type || '—'}</span>
          },
          { key: 'views', label: 'Views', nowrap: true,
            render: r => Number(r.views || 0).toLocaleString('fr-FR') },
          { key: 'status', label: 'Status',
            render: r => <StatusPill value={r.status} /> },
          { key: 'published_at', label: 'Published', nowrap: true,
            render: r => (r.published_at || '').slice(0, 10) },
        ]}
      />
    </div>
  );
}
